import { useQuery } from '@tanstack/react-query';
import { getBrowserClient } from '@/lib/supabase';
import { useHostessStore } from '@/stores/hostess';
import type { SalesStatus } from '~/types/customer-detail.types';

/** RPC 2 の JSONB 返却型 */
export interface CustomerActivitiesRpcData {
  activities: Array<{
    id: string;
    activity_date: string;
    activity_type: string;
    store_id: string | null;
    store_name: string | null;
    store_logo_path: string | null;
    hostess_id: string;
    hostess_name: string;
    hostess_status: string;
    hostess_profile_image_path: string | null;
    is_my_activity: boolean;
  }>;
  counts: {
    phone: number;
    message: number;
    letter: number;
    visit: number;
  };
  sales_status: SalesStatus;
}

export function useCustomerActivities(id: string | undefined) {
  const { hostess } = useHostessStore();
  const hostessId = hostess?.id;

  return useQuery<CustomerActivitiesRpcData>({
    queryKey: ['customer-activities', id, hostessId],
    queryFn: async () => {
      const supabase = getBrowserClient();
      const { data, error } = await supabase.rpc('get_customer_detail_activities', {
        p_customer_id: id!,
        p_hostess_id: hostessId ?? undefined,
      });

      if (error) throw new Error(`顧客活動取得エラー: ${error.message}`);
      return data as unknown as CustomerActivitiesRpcData;
    },
    enabled: !!id,
    staleTime: 1000 * 60 * 5,
  });
}
